<template>
  <div class="drawDetail">
    <div class="con flex jb ">
      <img src="./img/close.png"
           @click="back"
           class="close"/>
      <div class="big_img">
        <el-image fit="contain"
                  @click.prevent="clickImage()"
                  :src="square_data.img_url"
                  :preview-src-list="[square_data.raw_img_url]"
                  placeholder
                  v-if="img_type"
        >
        </el-image>
      </div>
      <div class="text_area">
        <div class="user flex jb ac">
          <div class="info flex  ac">
            <div class="avatar">
              <img src="@/views/objIcon/MJ.png"
                   alt=" "/>
            </div>
            <div class="name">
              <p class="nickname">白日梦</p>
              <p class="flex ac"><img src="./img/icon_img50.png" style="color: #FC8C0A;"
                                      alt=" "/><span>{{ square_data.views }}</span><img src="./img/icon_img51.png"
                                                                                        alt=" "/><span>{{
                  square_data.votes
                }}</span>
              </p>
            </div>
          </div>
          <div class="fav flex jc ac" @click="handleVote">
            <img src="./img/icon_img51.png"
                 alt=" "/>
            <p>点赞</p>
          </div>
        </div>
        <div class="item">
          <div class="title flex jb ac">
            <p>提示词</p>
            <p class="flex ac" v-clipboard:copy="square_data.prompt" v-clipboard:success="copySuccess"
               v-clipboard:error="copyError"><img src="./img/icon_img52.png" alt=" "/><span>复制</span></p>
          </div>
          <div class="desc">
            {{ square_data.prompt }}
          </div>
        </div>
        <div class="item">
          <div class="title flex jb ac">
            <p>英文</p>
            <p class="flex ac" v-clipboard:copy="square_data.prompt_en" v-clipboard:success="copySuccess"
               v-clipboard:error="copyError"><img src="./img/icon_img52.png"
                                                  alt=" "/><span>复制</span></p>
          </div>
          <div class="desc">
            {{ square_data.prompt_en }}
          </div>
        </div>
        <div class="item">
          <div class="title flex jb ac">
            <p>参数信息</p>
          </div>
          <div class="desc">
            <div class="params_item flex ac">
              <p class="title">绘制模型</p>
              <p class="tips">{{ square_data.img_model }}</p>
            </div>
            <div class="params_item flex ac">
              <p class="title">图片比例</p>
              <p class="tips">{{ square_data.aspect }}</p>
            </div>
            <div class="params_item flex ac">
              <p class="title">图片尺寸</p>
              <p class="tips">{{ square_data.width }}:{{ square_data.height }}</p>
            </div>
            <div class="params_item flex ac">
              <p class="title">高级参数</p>
              <p class="tips">{{ square_data.parameters }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <Login v-if="show_login_compoments"></Login>
  </div>
</template>

<script>
import utils from '../utils/index.js'
import newPay from "COMPONENTS/newPay.vue";
import Login from "COMPONENTS/Login.vue";
export default {
  components: {Login, newPay},
  data() {
    return {
      draw_id: this.$route.query.draw_id || 0,
      square_data: {},
      is_vote: 0,
      img_type: false,
    }
  },
  computed: {
    show_login_compoments() {
      return this.$store.state.show_login_compoments
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  created() {
    this.getData()
    this.fetchProfile()
  },
  methods: {
    getData() {
      //发送请求
      this.$http.get(`/front/aimj/draw/${this.draw_id}/`).then((res) => {


        this.square_data = res.data
        this.img_type = true

      })
    },
    back() {
      this.$router.go(-1)
    },
    handleVote() {
      this.$http.patch(`/front/aimj/draw/${this.draw_id}/`, {action: 'vote'}).then((res) => {
        if (this.is_vote) {
          this.is_vote = 0
          this.square_data.votes = this.square_data.votes - 1
        } else {
          this.is_vote = 1
          this.square_data.votes = this.square_data.votes + 1
        }
      })
    },
    copySuccess() {
      this.$message.success('复制成功！');
    },
    copyError() {
      this.$message.error('复制失败！');
    },

    clickImage() {
      // 下载图片
      this.$nextTick(() => {
        const wrapper = document.querySelector('.el-image-viewer__actions__inner');
        if (!wrapper) return;
        if (wrapper.querySelector('.my-download-btn')) return;

        const downBtn = document.createElement('i');
        downBtn.setAttribute('class', 'el-icon-download my-download-btn');
        // 绑定点击事件
        downBtn.addEventListener('click', async () => {
          if (!this.checkLogin()){

            return // 登录拦截
          }
          this.$http.get(`/front/aimj/draw/down/${this.draw_id}/`).then(res => {
            // 假设你用的是 axios 封装，res.data 才是后端 JSON
            if(res.status==200){
              window.location.href = res.data.url
            }else{
              console.log('不是200')
              let message = res.message
              utils.createErrTip(message)
            }
          }).catch(err => {
            console.error('下载失败', err);
            let message = err.message
            utils.createErrTip(message)
          });

        });

        wrapper.appendChild(downBtn);
      });
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
    fetchProfile() {
      if (localStorage.getItem('token')) {
        this.$http.get(`/front/user/profile/`).then(res => {
          if (res.status == '200') {
            this.$store.commit('setUserInfo', res.data)
            this.$store.commit('setIsLogin', true)
          }
        }).catch(() => {
          localStorage.removeItem('isTodyYouh')
          localStorage.removeItem('getY')
          localStorage.removeItem('paynum')
        }).finally(() => {

        })
      }

    },
  }
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;

}

.drawDetail {
  background: #1e1f22;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .con {
    width: 1000px;
    padding: 32px;
    background: #303237;
    border-radius: 15px;
    position: relative;

    .close {
      position: absolute;
      right: -70px;
      top: 0;
      width: 48px;
      height: 48px;
      cursor: pointer;
      opacity: 0.4;
    }

    .big_img {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 450px;
      height: 600px;
      max-width: 100%;
      max-height: 100%;
      padding: 0 30px 0 0;
      box-sizing: border-box;

      .el-image {
        width: 100%;
        height: 100%;
      }
    }

    .text_area {
      width: 480px;
      //          padding-right: 30px;
      .user {
        margin-bottom: 34px;

        .info {
          .avatar {
            width: 46px;
            height: 46px;
            background: #acacac;
            border-radius: 100%;
            overflow: hidden;
            margin-right: 10px;

            img {
              width: 100%;
            }
          }

          .name {
            p {
              img {
                width: 16px;
                height: 16px;
                opacity: 0.5;
              }

              span {
                margin-left: 5px;
                margin-right: 10px;
                font-size: 12px;
                color: #999;
                position: relative;
                top: 2px;
              }
            }

            .nickname {
              font-size: 14px;
              color: #fff;
              margin-bottom: 5px;
            }
          }
        }

        .fav {
          width: 80px;
          height: 40px;
          border-radius: 40px;
          background: #474858;
          cursor: pointer;

          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }

          p {
            font-size: 12px;
            color: #fff;
          }

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .item {
        width: 100%;
        margin-top: 10px;

        .title {
          p {
            font-size: 14px;
            color: #fff;
          }

          img {
            width: 24px;
            height: 24px;
            opacity: 0.7;
          }

          span {
            font-size: 12px;
            color: #999;
          }

          .flex {
            cursor: pointer;

            &:hover {
              img {
                opacity: 1;
              }

              span {
                color: #fff;
              }
            }
          }
        }

        .desc {
          width: 100%;
          background-color: #262626;
          color: #fff;
          padding: 16px;
          height: auto;
          //min-height: 60px;
          //max-height: auto;
          border-radius: 10px;
          line-height: 1.7;
          margin-top: 10px;;

          .params_item {
            padding: 5px 0;

            .title {
              //width: 100px;
              color: #949ba4;
              margin-right: 10px;
            }

            .tips {
              flex: 1;
              color: #fff;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
</style>